import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {
    VirtualNin
} from "../../redux/selfService/selfServiceSlice";
import React, {useState} from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import SuccessModal from "../../components/SuccessModal";
import Card from "../../components/Base/Card";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import BaseDatePicker from "../../components/Base/BaseDatePicker";
import BaseTimePicker from "../../components/Base/BaseTimePicker";

const todaysDate = new Date();
const nineAMToday = new Date(todaysDate.getFullYear(),todaysDate.getMonth()+1,todaysDate.getDate(),9,0,0,0)
const purposeValues = ["Recapture", "KYC", "PIN Generation"];

const VirtualNinPage = ()=>{
    const dispatch = useAppDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const { allBanks, isLoading } = useAppSelector((state) => state?.selfService);


    const validationSchema = Yup.object().shape({
        virtualNIN: Yup.string().required("Please enter the your Nin number"),
        issuanceDate: Yup.string().required("Please add NIN issuance date"),
        issuanceTime: Yup.string().required("Please add NIN issuance time"),
        purpose: Yup.number().required("Please enter purpose"),
    });

    const defaultValues = {
        virtualNIN: "",
        issuanceDate: "",
        issuanceTime: "09:00",
        purpose: 0
    }

    const { handleSubmit, register, setValue, reset, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues
    });


    // Use named functions for clarity
const parseTime = (timeString) => {
    const [hour, min] = timeString.split(":").map((a) => parseInt(a.trim(), 10));
    return { hour, min };
  };
  const formatDate = (dateString, timeString) => {
    const [hour, min] = timeString.split(":").map((a) => parseInt(a.trim(), 10));
    const [year, month, day] = dateString.split("-").map((a) => parseInt(a.trim(), 10));
  
    // Create a date in the user's local timezone
    const localDate = new Date(year, month - 1, day, hour, min);
  
    // Get the UTC timestamp of the local date
    const utcTimestamp = localDate.getTime();
  
    // Create a new Date object in UTC timezone
    const utcDate = new Date(utcTimestamp);
  
    return utcDate;
  };
  
    const onSubmit = (values: any) => {
      console.log('values na ', values)
    //  const [hour, min] = values.issuanceTime.split(":").map((a:string)=>parseInt(a.trim(), 10));
    //  const issuanceDate = new Date(values.issuanceDate)

     // const dateTime = new Date(issuanceDate.getFullYear(), issuanceDate.getMonth(), issuanceDate.getDay(), hour,  min);
    //   delete values.issuanceTime;
    //   delete values.issuanceDate;
    //     const formattedValues = {
    //         ...values,
    //         issuanceDateTime: dateTime,
    //     }

        const { issuanceDate, issuanceTime, ...restValues } = values;
        const dateTime = formatDate(issuanceDate, issuanceTime);
  
        const formattedValues = {
          ...restValues,
          issuanceDateTime: dateTime,
        };

        console.log(formattedValues);
        
        dispatch(VirtualNin(formattedValues)).then(res=>{
            console.log("**********************************");
            console.log(res);
            if(res?.type === 'selfService/VirtualNin/fulfilled'){
                setSuccessMessage(res?.payload?.statusMessage);
                reset(defaultValues)
              //  setShowSuccessModal(true)
            }
        })
    }
    return (
        <div className="statement-page">
            <PageName pageName={"VNin"}/>
            <div>
                <SuccessModal
                    showModal={showSuccessModal}
                    onClose={()=>setShowSuccessModal(false)}
                    note={successMessage}
                />
                <div className="mx-4">
                    <div className="h1 text-grayscaleBody">
                        VNIN
                    </div>
                    <div className="w-full">
                        <Card className="mb-8 bg-grayscaleBG">
                            <div className="section-card">
                                <div className="pt-12 whitespace-pre mr-6">
                                    VNIN
                                </div>
                                <div className="w-full">
                                    <div className="mx-auto max-w-[400px]">
                                        <div className="form__group">
                                            <label htmlFor="vnin" className="form__label">
                                                VNin <Required />
                                            </label>
                                            <input placeholder="VNin" type="text" id="vnin"
                                                   className="form__input" {...register("virtualNIN")} />
                                            {errors.virtualNIN && (
                                                <ErrorViewer message={errors.virtualNIN.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="issuanceDate" className="form__label">
                                                Issuance Date <Required />
                                            </label>
                                            <BaseDatePicker
                                                onChange={(date: Date) => {
                                                    // @ts-ignore
                                                    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

                                                    // Format the date to "YYYY-MM-DD"
                                                    const formattedDate = localDate.toISOString().split("T")[0];
                                                    
                                                    setValue("issuanceDate", formattedDate);
                                                }}
                                            />
                                            {errors.issuanceDate && (
                                                <ErrorViewer message={errors.issuanceDate.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="issuanceTime" className="form__label">
                                                Issuance Time
                                            </label>
                                            <BaseTimePicker
                                                initialValue={nineAMToday}
                                              onChange={(val)=>setValue('issuanceTime', val)}
                                            />
                                          {errors.issuanceTime && (
                                            <ErrorViewer message={errors.issuanceTime.message as string}/>
                                          )}
                                        </div>
                                      <div className="form__group">
                                        <label htmlFor="purpose" className="form__label">
                                          Purpose
                                        </label>
                                        <select id="purpose" defaultValue="" className="form__select" {...register("purpose")}>
                                          <option value="" disabled>Select Purpose</option>
                                          {
                                            purposeValues.map((purpose, index)=>(
                                              <option key={index} value={index}>{purpose}</option>
                                            ))
                                          }
                                        </select>
                                        {errors.purpose && (
                                          <ErrorViewer message={errors.purpose.message as string}/>
                                        )}
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <div className="flex justify-end text-primary mb-40">
                            <button
                                className="btn btn-primary font-semibold mr-4"
                                onClick={handleSubmit(onSubmit)}
                                disabled={isLoading}
                            >
                                {
                                    isLoading ? <LoadingSpinner /> : "Send NIN"
                                }
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default VirtualNinPage;